// Shared by Reach's pivot and export filter editors. Saved condition ids stay unchanged.

export const PIVOT_FILTER_OPERATORS = [
  { id: 'list', label: 'List of', needsValue: false },
  { id: 'is', label: 'Is', needsValue: true },
  { id: 'is_not', label: 'Is not', needsValue: true },
  { id: 'contains', label: 'Contains', needsValue: true },
  { id: 'not_contains', label: "Doesn't contain", needsValue: true },
  { id: 'starts_with', label: 'Starts with', needsValue: true },
  { id: 'ends_with', label: 'Ends with', needsValue: true },
  { id: 'is_empty', label: 'Is empty', needsValue: false },
  { id: 'is_not_empty', label: 'Is not empty', needsValue: false },
];


export function matchesPivotCondition(value, operator, filterValue) {
  const source = String(value ?? '').trim().toLowerCase();
  const target = String(filterValue ?? '').trim().toLowerCase();
  if (!target && operator !== 'is_empty' && operator !== 'is_not_empty') return true;
  if (operator === 'is') return source === target;
  if (operator === 'is_not') return source !== target;
  if (operator === 'contains') return source.includes(target);
  if (operator === 'not_contains') return !source.includes(target);
  if (operator === 'starts_with') return source.startsWith(target);
  if (operator === 'ends_with') return source.endsWith(target);
  if (operator === 'is_empty') return source.length === 0;
  if (operator === 'is_not_empty') return source.length > 0;
  return true;
}

export function dataFilterDefinitions(rows, streams, dimensionFields) {
  return [
    { id: 'stream', label: 'Data stream', values: streams.map(item => ({ id: item.id, label: item.name })) },
    ...dimensionFields.filter(field => !['stream', 'date'].includes(field.id)).map(field => ({
      id: field.id, label: field.label, calculated: Boolean(field.calculated),
      values: [...new Set(rows.map(row => row[field.id]).filter(value => value !== null && value !== undefined && value !== ''))]
        .sort((left, right) => String(left).localeCompare(String(right), undefined, { numeric: true }))
        .map(value => ({ id: value, label: String(value) })),
    })),
  ];
}

export function activeDataFilters(definitions, streams, state) {
  return definitions.filter(({ id }) => {
    const operator = state.filterOperators[id] || 'list';
    if (operator === 'list') return id === 'stream'
      ? state.selectedStreamIds.length !== streams.length
      : (state.dimensionFilters[id] || []).length > 0;
    return ['is_empty', 'is_not_empty'].includes(operator) || Boolean((state.filterText[id] || '').trim());
  });
}

// Never let a dialog draft mutate its parent, including arrays from older saved pivots.
export function cloneDataFilterState(state) {
  return { selectedStreamIds: [...state.selectedStreamIds],
    dimensionFilters: Object.fromEntries(Object.entries(state.dimensionFilters).map(([key, values]) => [key, [...values]])),
    filterOperators: { ...state.filterOperators }, filterText: { ...state.filterText } };
}

export function validDataFilterState(state, chosen) {
  return state.selectedStreamIds.length > 0 && !chosen.some(id =>
    PIVOT_FILTER_OPERATORS.find(item => item.id === (state.filterOperators[id] || 'list'))?.needsValue
      && !(state.filterText[id] || '').trim());
}

// A stream-name condition must search all streams at the current level/granularity,
// not just the stream chosen before that condition was added.
export function streamIdForFilter(selectedStreamIds, filterOperators) {
  return (filterOperators.stream || 'list') === 'list' && selectedStreamIds.length === 1
    ? selectedStreamIds[0] : undefined;
}
